import { AGE_LINE, PRIVACY_PATH, TERMS_PATH } from "../lib/consent";

// The two consent boxes (ba-005), shared by sign-up and the one-time check
// for accounts made before them (ba-011), so both ask the same thing.

const B = { fontFamily: "'Geist', 'Helvetica Neue', sans-serif" };
const SUB = "#C9C2B8";
const ACCENT = "#9AA6D6";

// Padding makes a 44px tap area; the matching negative margin keeps the
// sentence where it was.
const linkStyle = { color: ACCENT, textDecoration: "underline", textUnderlineOffset: 2, display: "inline-block", padding: "14px 5px", margin: "-14px -5px" };

// The box is drawn at 20px inside a 44px input, so the tap area is 44px
// without making the row taller.
const box = (checked) => `url("data:image/svg+xml,${encodeURIComponent(checked
  ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><rect x="0.5" y="0.5" width="19" height="19" rx="4" fill="#9AA6D6" stroke="#9AA6D6"/><path d="M5 10.5l3.2 3.2L15 7" fill="none" stroke="#0C0E1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><rect x="0.75" y="0.75" width="18.5" height="18.5" rx="4" fill="none" stroke="#A8A098" stroke-width="1.5"/></svg>')}")`;

function CheckRow({ checked, onChange, children, id }) {
  return (
    <label htmlFor={id} style={{ ...B, display: "flex", alignItems: "flex-start", gap: 12, fontSize: 13.5, color: SUB, lineHeight: 1.5, padding: "10px 0", minHeight: 44, cursor: "pointer" }}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          appearance: "none", WebkitAppearance: "none", width: 44, height: 44, margin: "-11px -12px -11px -12px", flexShrink: 0,
          background: `${box(checked)} center / 20px 20px no-repeat`, border: "none", borderRadius: 10, cursor: "pointer",
        }}
      />
      <span>{children}</span>
    </label>
  );
}

export function ConsentBoxes({ ageOk, onAge, consentOk, onConsent, idPrefix = "consent" }) {
  return (
    <>
      <CheckRow checked={ageOk} onChange={onAge} id={`${idPrefix}-age`}>I'm {AGE_LINE} or older.</CheckRow>
      <CheckRow checked={consentOk} onChange={onConsent} id={`${idPrefix}-save`}>
        Save my birth details and anything I add later to my account. I agree to the{" "}
        <a href={TERMS_PATH} target="_blank" rel="noopener noreferrer" style={linkStyle}>Terms</a> and the{" "}
        <a href={PRIVACY_PATH} target="_blank" rel="noopener noreferrer" style={linkStyle}>Privacy policy</a>.
      </CheckRow>
    </>
  );
}

// The message when a box is left empty, the same at sign-up and the check.
export function consentMissing(ageOk, consentOk, verb = "make your account") {
  if (!ageOk && !consentOk) return `Tick both boxes to ${verb}.`;
  if (!ageOk) return `Tick the first box to confirm you're ${AGE_LINE} or older.`;
  return "Tick the second box so we can save your chart to your account.";
}
